import { render, staticRenderFns } from "./MessageSnackbar.vue?vue&type=template&id=066c87f7"
import script from "./MessageSnackbar.vue?vue&type=script&lang=js"
export * from "./MessageSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports